import { render, staticRenderFns } from "./Finanzas2.vue?vue&type=template&id=3357f780&"
import script from "./Finanzas2.vue?vue&type=script&lang=js&"
export * from "./Finanzas2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports